<div class="ttn-container gap-2" [formGroup]="form">
  <!-- Hotkey hint -->
  <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.85rem; color: #666">
    <strong>{{ 'hotkeys' | translate }}:</strong>
    <span class="ms-2">Enter - {{ 'next_field' | translate }}</span>
    <span class="ms-2">•</span>
    <span class="ms-2">{{ getModifierKey() }}+Enter - {{ 'submit_form' | translate }}</span>
  </div>

  <div>
    <app-text-field
      #ttnField
      class="w-100"
      [type]="'default'"
      label="{{ 'ttn' | translate }}"
      [required]="true"
      mask="0*"
      [maxLength]="14"
      [formControl]="form.controls.ttn"
      (focusout)="form.controls.ttn.markAsTouched()"
      [error]="form.controls.ttn.touched && form.controls.ttn.invalid"
    ></app-text-field>
    @if (form.controls.ttn.touched && form.controls.ttn.invalid) {
      <mat-hint class="text-danger notify-of-size">
        @if (form.controls.ttn.errors?.['required']) {
          {{ 'field_cannot_be_empty' | translate }}
        }
        @if (form.controls.ttn.errors?.['minlength']) {
          {{ 'min_value' | translate }} {{ form.controls.ttn.errors?.['minlength'].requiredLength }}
        }
        @if (form.controls.ttn.errors?.['maxlength']) {
          {{ 'max_value' | translate }} {{ form.controls.ttn.errors?.['maxlength'].requiredLength }}
        }
      </mat-hint>
    }
  </div>

  @if (!isUpdate) {
    <app-phone-field
      #phoneField
      class="w-100"
      [type]="'default'"
      label="{{ 'phone_number' | translate }}"
      [required]="true"
      [formControl]="form.controls.phone"
      [error]="isFormSubmitted && form.controls.phone.status === 'INVALID'"
    ></app-phone-field>
  }
  @if (isFormSubmitted && form.controls.phone.status === 'INVALID') {
    <div class="d-flex align-items-center">
      <span style="color: #ff381a; font-size: 12px; margin-top: -8px">{{ 'field_cannot_be_empty' | translate }}..</span>
    </div>
  }

  @if (form.controls.comments.errors?.['required']) {
    <div class="text-danger">{{ 'max_characters' | translate }} 200.</div>
  }

  <div class="d-flex flex-column w-100">
    <label class="text-label">{{ 'comment' | translate }}</label>
    <textarea
      #commentsField
      class="pt-2 area-border crm-scroll p-2"
      id="text-area"
      type="text"
      maxlength="5000"
      [formControl]="form.controls.comments"
    ></textarea>
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div>
        @if (form.controls.comments.errors?.['maxlength']) {
          <div class="text-danger notify-of-size">{{ 'max_characters' | translate }} 5000.</div>
        }
      </div>
      <div>
        <mat-hint align="end">{{ form.controls.comments.value.length }}/5000</mat-hint>
      </div>
    </div>
  </div>
</div>

<mat-divider></mat-divider>

<div class="d-flex p-3" mat-dialog-actions>
  <app-button class="btn-cancel" (onChangeClick)="onNoClick()" [btnType]="'no-border'">
    <span class="cancel-color">
      {{ 'cancel' | translate }}
    </span>
  </app-button>
  <div class="flex-fill"></div>
  @if (!isUpdate) {
    <app-button class="ms-2" [disabled]="form.invalid" (onChangeClick)="onSubmit()">
      {{ 'add' | translate }}
    </app-button>
  }

  @if (isUpdate) {
    <app-button
      class="ms-2"
      [disabled]="form.controls.ttn.invalid || form.controls.comments.invalid"
      (onChangeClick)="onUpdate()"
    >
      {{ 'update' | translate }}
    </app-button>
  }
</div>
